<div class="page-header">
	<h1 class="page-title">Agent List</h1>
	<div class="page-actions">
		<a class="btn btn-primary" [routerLink]="['/agent','provision']" *hasPermission="['AgentProvisioning']">Provision</a>
	</div>
</div>

<div class="row mt-3">
	<div class="col">
		<app-table
			[downloadHeading]="'Agent List'"
			[downloadName]="'agent_list'"
			[queryOnInit]="true"
			[data]="results"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[filters]="filters"
			[loading]="loading"
			(onRowClick)="open($event)"
			(onUpdateRequired)="doFetchResults($event)"
			>
			<ng-template #online let-row="row">
				<td>
					<nz-icon nzType="clock-circle" nzTheme="fill" [ngClass]="{'text-secondary': row.online == undefined, 'text-success': row.online == true, 'text-danger': row.online == false}"/>
				</td>
			</ng-template>
			<ng-template #lastUsed let-row="row">
				<td *ngIf="row.lastUsedAt">{{row.lastUsedAt | date}}</td>
				<td *ngIf="!row.lastUsedAt">-</td>
			</ng-template>
			<ng-template #givenNames let-row="row">
				<td>
					{{row.firstName??''}} {{row.secondName??''}} {{row.otherNames??''}}
				</td>
			</ng-template>
		</app-table>
	</div>
</div>
